import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
  generatePreArrivalDocuments,
  generatePreDepartureDocuments,
  getPortInstructions,
  getRequiredDocuments,
  selectDocuments,
} from '../../../slices/documentsSlice';
import { selectGeneralData } from '../../../slices/portCallSlice';

import SummaryDocumentsBlock from './SummaryDocumentsBlock';
import { NotificationAlert } from '../../../../global/alertModal/alertModal';
import Page from '../../../../layout/components/Page';
import PageHeader from '../../../../layout/components/PageHeader';

import '../styles/summary.scss';

function Summary() {
  const params = useParams();
  const dispatch = useDispatch();
  const portCallDocuments = useSelector(selectDocuments)?.documents;
  const instructionsApiDocs = useSelector(
    (state) => state.documents.portInstructions
  );
  const [showLoadingAllDocuments, setShowLoadingAllDocuments] = useState(false);
  const [showLoadingSpecificDocument, setShowLoadingSpecificDocument] =
    useState(false);
  const [instructionCallDispatched, setInstructionCallDispatched] =
    useState(false);
  const generalPortcallData = useSelector(selectGeneralData);

  let instructions = [];
  if (
    portCallDocuments?.instructionsDocuments &&
    portCallDocuments?.instructionsDocuments.length > 0
  ) {
    instructions = portCallDocuments?.instructionsDocuments?.map((_) =>
      _.name ? _ : { ..._, name: 'Instruction Document' }
    );
  }
  if (instructionsApiDocs && instructionsApiDocs.length > 0) {
    instructions = instructions.concat(instructionsApiDocs);
  }

  useEffect(() => {
    setShowLoadingAllDocuments(true);
    dispatch(generatePreArrivalDocuments({ uid: params.uid })).finally(() => {
      dispatch(generatePreDepartureDocuments({ uid: params.uid })).finally(
        () => {
          dispatch(getRequiredDocuments({ uid: params.uid })).finally(() => {
            setShowLoadingAllDocuments(false);
          });
        }
      );
    });
  }, [params.uid, dispatch]);

  useEffect(() => {
    if (
      generalPortcallData?.unlocode &&
      generalPortcallData?.agent?.uid &&
      !instructionCallDispatched
    ) {
      dispatch(
        getPortInstructions({
          portUnloCode: generalPortcallData?.unlocode,
          agentCompanyUid: generalPortcallData?.agent?.uid,
        })
      );
      setInstructionCallDispatched(true);
    }
  }, [generalPortcallData, dispatch]);

  return (
    <Page>
      <div className="summary">
        <NotificationAlert
          id={'Alert-Information'}
          alertType={'information'}
          isOpened={showLoadingAllDocuments || showLoadingSpecificDocument}
          setIsOpened={(open) => {
            setShowLoadingAllDocuments(open);
            setShowLoadingSpecificDocument(open);
          }}
          title={'Document generation in progress'}
          message={'Your documents will be ready in a few seconds.'}
          showCloseButton={false}
        />
        <PageHeader
          title={'Summary'}
          subtitle={`If you see missing or incorrect information, please correct it going to the section in the left side menu.`}
        />
        <SummaryDocumentsBlock
          title={'Cargo documents'}
          emptyDocumentsMessage={'There are no cargo documents.'}
          documents={portCallDocuments?.cargoDocuments}
          uploadSlice={getRequiredDocuments}
          updateDocuments={showLoadingAllDocuments}
          setShowLoadingAlert={setShowLoadingSpecificDocument}
        />
        <SummaryDocumentsBlock
          title={'Local formalities'}
          emptyDocumentsMessage={
            'There are no general local formalities documents.'
          }
          documents={portCallDocuments?.localFormalities}
          uploadSlice={getRequiredDocuments}
          updateDocuments={showLoadingAllDocuments}
          setShowLoadingAlert={setShowLoadingSpecificDocument}
        />
        <SummaryDocumentsBlock
          title={'General pre-arrival documents'}
          emptyDocumentsMessage={'There are no general pre-arrival documents.'}
          documents={portCallDocuments?.preArrivalDocuments}
          uploadSlice={generatePreArrivalDocuments}
          updateDocuments={showLoadingAllDocuments}
          setShowLoadingAlert={setShowLoadingSpecificDocument}
        />
        <SummaryDocumentsBlock
          title={'General pre-departure documents'}
          emptyDocumentsMessage={'There are no general pre-arrival documents.'}
          documents={portCallDocuments?.preDepartureDocuments}
          uploadSlice={generatePreDepartureDocuments}
          updateDocuments={showLoadingAllDocuments}
          setShowLoadingAlert={setShowLoadingSpecificDocument}
        />
        <SummaryDocumentsBlock
          title={'Ship certificates requested by agent'}
          emptyDocumentsMessage={'There are no ship certificates.'}
          updateDocuments={showLoadingAllDocuments}
          setShowLoadingAlert={setShowLoadingSpecificDocument}
          documents={portCallDocuments?.requestedCertificates}
          uploadSlice={getRequiredDocuments}
        />
      </div>
    </Page>
  );
}

export default Summary;
